import React from "react";
import { testimonials } from "../data/testimonials";

const TestimonialsOne = () => {
  return (
    <div className="testimonial-area-1 space overflow-hidden">
      <div className="container">
        <div className="title-area text-center mb-50">
          <span className="sub-title">Testimonios</span>
          <h2 className="sec-title">Lo que dicen nuestros clientes</h2>
          <p className="sec-text">
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación
          </p>
        </div>

        <div className="row gy-4">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="col-lg-4 col-md-6">
              <div className="testimonial-card">
                <div className="testimonial-card-top">
                  <div className="rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>
                </div>
                <div className="testimonial-card-content">
                  <p className="testimonial-text">"{testimonial.quote}"</p>
                </div>
                <div className="testimonial-card-bottom">
                  <div className="testimonial-author">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <span className="author-service">{testimonial.service}</span>
                    <span className="author-location">
                      <i className="fas fa-map-marker-alt"></i> {testimonial.location}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsOne;
